import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { detectBackendFromUrl } from '../../constants/api-routing';

@Injectable()
export class BackendRouteLoggerInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const backend = detectBackendFromUrl(req.url);
    console.info(`[API ROUTER] backend=${backend} method=${req.method} url=${req.url}`);
    return next.handle(req);
  }
}